import { render, staticRenderFns } from "./PaymentList.vue?vue&type=template&id=e8c0d4de&scoped=true&lang=pug&"
import script from "./PaymentList.vue?vue&type=script&lang=js&"
export * from "./PaymentList.vue?vue&type=script&lang=js&"
import style0 from "./PaymentList.vue?vue&type=style&index=0&id=e8c0d4de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c0d4de",
  null
  
)

/* custom blocks */
import block0 from "./PaymentList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCol,VRow,VSimpleTable})
